/**
 * PageLayout - 背景画像 + LPカード中央寄せレイアウト
 *
 * 構造:
 *   fixed背景(bg.png) → 390px中央寄せカラム → children
 *
 * bg-fixed はモバイルブラウザで効かないため、
 * fixed + inset-0 の div で背景画像を敷く。
 */
const PageLayout = ({ children }) => {
  const bgImagePath = `/images/common/bg.png`;

  return (
    <div className="relative" style={{ minHeight: '100dvh' }}>
      {/* 共通背景画像（固定・最下層） */}
      <div
        className="fixed inset-0 -z-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bgImagePath})` }}
        aria-hidden="true"
      />
      {/* 背景を明るくする白オーバーレイ（bg.pngの上・地図の下） */}
      <div
        className="fixed inset-0 -z-20 bg-white/40"
        aria-hidden="true"
      />
      {/* 390px 中央寄せカラム — overflow-clip で子の fixed が外に出ないようにする */}
      <div className="relative mx-auto w-full max-w-lp overflow-clip" style={{ minHeight: '100dvh' }}>
        {children}
      </div>
    </div>
  );
};

export default PageLayout;
